// Nombre de MÓDULO (enum estable, PHI-safe) de una ruta, para la telemetría. Vivía en App.js; se
// movió acá para que `carga_app` (#1717 R13, helpers/carga-app.js) use el MISMO enum y no el primer
// segmento crudo de la URL (O11 del revisor v2).
// Mapea un pathname a un nombre de MÓDULO (enum estable, PHI-safe) para la
// telemetría `module_open`. Devuelve el nombre de la VISTA, nunca la URL con
// params (ej. /record/123 → "record", sin el id). Deep-links y rutas anidadas
// se colapsan a su vista raíz.
export function moduleFromPathname(pathname) {
  const p = (pathname || "/").split("?")[0];
  if (p === "/" || p === "/home") return "home";
  if (p === "/authentication") return "authentication";
  if (p === "/turno") return "turno";
  if (p === "/visualizador-examenes") return "visualizador";
  if (p === "/recuperar-clave") return "recuperar_clave";
  if (p === "/nueva-clave") return "nueva_clave";
  if (p.startsWith("/recetas-ambulatorias")) return "recetas";
  if (p === "/informes") return "informes";
  if (p === "/complicaciones") return "complicaciones";
  if (p === "/transcriptor") return "transcriptor";
  if (p === "/finder") return "finder";
  if (p === "/epicrisis-radonc") return "epicrisis_radonc";
  if (p === "/raw-query") return "raw_query";
  if (p.startsWith("/record/")) return "record";
  if (p.startsWith("/graph/")) return "graph";
  if (p.startsWith("/comunidad")) return "comunidad";
  if (p.startsWith("/directorio") || p.startsWith("/u/")) return "directorio";
  if (p.startsWith("/perfil")) return "perfil";
  if (p.startsWith("/admin/")) return "admin";
  return "otro";
}
